module.exports = __webpack_public_path__ + "img/mainstage.9172df36.jpg";